import { FaCreditCard } from "react-icons/fa";
import styles from "../css/invoice.module.css";

export default function ServiceSelection({ 
  serviceOptions, 
  selectedService, 
  onServiceChange, 
  onAddService 
}) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <FaCreditCard style={{ color: '#A78BFA', marginRight: '8px' }} />
        Add Services
      </div>

      <div className={styles.addRow}>
        <select
          className={styles.dropdown}
          value={selectedService}
          onChange={(e) => onServiceChange(e.target.value)}
        >
          <option value="">Select Service</option>
          {(serviceOptions || []).map((s) => (
            <option key={s?.serviceid} value={String(s?.serviceid)}>
              {s?.servicename} — R{s?.price}
            </option>
          ))}
        </select>

        <button className={styles.addBtn} onClick={onAddService}>
          + Add
        </button>
      </div>
    </div>
  );
}
